import { useCallback } from "react";

export type TTableBuilderDomNodeRefMap = React.MutableRefObject<Map<string, HTMLElement>>;

export function useTableBuilderDomNodeRefMapRegistration(id: string, domNodeRefMap: TTableBuilderDomNodeRefMap) {
  return useCallback(
    (el: HTMLElement) => {
      if (el != null) {
        domNodeRefMap.current.set(id, el);
      } else {
        domNodeRefMap.current.delete(id);
      }
    },
    [id],
  );
}